<template>
  <GridContainer class="google-teasers">
    <GridRow>
      <GridColumn
        v-for="(teaser, index) in teaserItems"
        :key="teaser.title"
        :sm="6"
      >
        <ImageTeaser
          animate-tile
          lazy
          :heading="{
            text: teaser.title,
            tag: 'h2',
          }"
          :animation-delay="index + 1"
          class="google-teasers__item"
          :background="teaser.background"
        >
          <template #button>
            <LinkButton
              :to="teaser.button.url"
              primary
              tag="nuxt-link"
            >
              {{ teaser.button.label }}
            </LinkButton>
          </template>
        </ImageTeaser>
      </GridColumn>
    </GridRow>
  </GridContainer>
</template>

<script>
import {
  ImageTeaser,
  GridContainer,
  GridRow,
  GridColumn,
  LinkButton,
} from '@i22/td-longtail-vue-components';

export default {
  name: 'GoogleTeasers',
  components: {
    GridContainer,
    GridRow,
    GridColumn,
    LinkButton,
    ImageTeaser,
  },
  props: {
    teaserItems: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

$image-teaser: '.image-teaser';

.google-teasers {
  &__item {
    margin-bottom: 3rem;

    @include mq($mq-md) {
      margin-bottom: 6rem;
    }
  }
}

:deep(.image-teaser__container) {
  width: 100%;
  max-width: 200px;
  padding: 4rem 0;

  @include mq($mq-sm) {
    max-width: none;
    padding: 0;
  }
}
</style>
